import { integerFormatter, numberFormatter, healthColorAlertFormatter, percentageBarFormatter } from "../../gridFormatters";
export const vmdkDefs = [
    {
        "field": "vmdk_name",
        "headerName": "VMDK Name",
        "filter": "agTextColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "datastore_name",
        "headerName": "Datastore Name",
        "filter": "agTextColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "vmdk_size",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "VMDK Size",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "vmdk_used",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "VMDK Used",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "disk_type",
        "headerName": "Disk Type",
        "filter": "agTextColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "datastore_size",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Datastore Size",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "datastore_used",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Datastore Used",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "datastore_free",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Datastore Free",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    }

]

export const datastoreSummaryAag = [
	{
		"field": "datastore_name",
		"icon": true,
		"mobile": true
	},
	{
		"field": "datastore_size",
		"icon": true,
		"mobile": true
	},
	{
		"field": "datastore_used",
		"style": {
			"color": "blue"
		}
	},
	{
		"field": "num_clusters",
		"icon": true,
		"mobile": true
	},
	{
		"field": "num_esx_hosts",
		"icon": true,
		"mobile": true
	},
	{
		"field": "num_vms",
		"icon": true,
		"mobile": true
	},
	{
		"field": "sum_vmdks",
		"icon": true,
		"mobile": true
	},
	{
		"field": "over_provisioned",
		"icon": true,
		"mobile": true
	},
	{
		"field": "unprovisioned_free",
		"style": {
			"color": "purple"
		}
	},
	{
		"field": "provisioned_free",
		"style": {
			"color": "purple"
		}
	},
	{
		"field": "allocated",
		"style": {
			"color": "purple"
		}
	},
	{
		"field": "usable",
		"style": {
			"color": "purple"
		}
	}
];

export const datastoreDefs = [
    {
        "field": "vm_name",
        "headerName": "VM Name",
        "filter": "agTextColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "num_cpus",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "headerName": "Num CPUs",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "total_mhz",
        "type": "numericColumn",
        "headerName": "Total Mhz",
        "filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "ghz_per_cpu",
        "type": "numericColumn",
        "headerName": "Ghz / CPU",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "vm_util",
        "type": "numericColumn",
        "headerName": "% CPU Util",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": percentageBarFormatter
    },
    {
        "field": "memory_allocated",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Memory Allocated",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "memory_util",
        "type": "numericColumn",
        "headerName": "% Memory Util",
        "filter": "agNumberColumnFilter",
        "cellRenderer": percentageBarFormatter,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "disk_allocated",
        "type": "numericColumn",
        "headerName": "Disk Allocated",
        "filter": "agNumberColumnFilter",
      'cellRenderer': numberFormatter,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "disk_used",
        "type": "numericColumn",
        "headerName": "Disk Used",
        "filter": "agNumberColumnFilter",
      'cellRenderer': numberFormatter,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "disk_util_pct",
        "type": "numericColumn",
        "headerName": "% Disk Used",
        "filter": "agNumberColumnFilter",
        "cellRenderer": percentageBarFormatter,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "os",
        "headerName": "OS",
    },
    {
        "field": "overall_status",
        "cellRenderer": healthColorAlertFormatter,
        "cellStyle": {
            "textAlign": "center"
        },
        "headerName": "Overall Status"
    },
    {
        "field": "datacenter_name",
        "headerName": "Datacenter Name"
    },
    {
        "field": "esx_host_name",
        "headerName": "ESX Host Name"
    },
    {
        "field": "cluster_name",
        "headerName": "Cluster Name"
    },
    {
        "field": "vcenter_name",
        "headerName": "Vcenter Name"
    },
    {
        "field": "device_type_code",
        "headerName": "Device Type Code",
        "hide": true
    }
];
